import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ProductPersoanlInfo from '../product/productPersoanlInfo';
import Confirmodal from './confirmModal';
import axios from 'axios';

const ContactPartner = () => {
  const { pathname } = useLocation();
  const partnerRef = useRef([]);
  const locationRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const emailForm = /^[a-zA-Z]+\.[a-zA-Z]+$/;
  const emailId = /^[A-Za-z0-9-._]*$/g;

  const initialValue = {
    cor_name: '',
    mng_name: '',
    phone1: '010',
    phone2: '',
    phone3: '',
    emailAccount: '',
    emailDomain: '',
    contents: '',
  };
  const [value, setValue] = useState({ ...initialValue });
  const [agree, setAgree] = useState(false);
  const { cor_name, mng_name, phone1, phone2, phone3, emailAccount, emailDomain, contents } = value;
  const [closePopUp, setClosePopUp] = useState(false);

  const handleOnChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmitRequest = useCallback(
    async (e) => {
      // 문의하기 요청
      e.preventDefault();
      if (loading) {
        return false;
      }
      for (let i = 0; i < partnerRef.current.length; i++) {
        if (partnerRef.current[i].value === '' || !partnerRef.current[i].value.trim()) {
          alert(partnerRef.current[i].title);
          partnerRef.current[i].focus();
          return false;
        }
      }
      if (partnerRef.current[2]?.value?.length < 3) {
        alert('연락처를 확인해주세요.');
        partnerRef.current[2].focus();
        return false;
      }
      if (partnerRef.current[3]?.value?.length < 4) {
        alert('연락처를 확인해주세요.');
        partnerRef.current[3].focus();
        return false;
      }
      if (!emailId.test(emailAccount)) {
        alert('이메일 아이디를 확인해주세요. (특수문자는 ".-_"만 허용됩니다.)');
        partnerRef.current[4].focus();
        return false;
      }
      if (!emailForm.test(emailDomain)) {
        alert('이메일 도메인을 확인해주세요');
        partnerRef.current[5].focus();
        return false;
      }
      if (agree === false) {
        alert('개인정보 수집 및 이용을 동의해주세요.');
        return false;
      }
      try {
        setLoading(true);
        const data = value;
        delete data?.phone1;
        delete data?.phone2;
        delete data?.phone3;
        delete data?.emailAccount;
        delete data?.emailDomain;
        await axios
          .post(
            'https://backwithus.kiwontech.com/customer/alliance/save',
            {
              ...data,
              phone: `${phone1}-${phone2}-${phone3}`,
              email: `${emailAccount}@${emailDomain}`,
            },
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            },
          )
          .then((res) => {
            console.log(res.config.url);
            setValue({ ...initialValue });
            setAgree(false);
          });
      } catch (error) {
        alert('오류가 발생했습니다. 관리자에게 연락 부탁드립니다.');
      } finally {
        setLoading(false);
      }
      // 팝업 닫기
      setClosePopUp((prev) => !prev);
    },
    [value, agree],
  );

  const closePopup = useCallback(() => {
    setConfirm(true);
    setClosePopUp(!closePopUp);
  }, [closePopUp, setClosePopUp, confirm, setConfirm]);

  useEffect(() => {
    if (pathname === '/contact-us/partner/contact-us') {
      const posY = locationRef?.current?.offsetTop;
      window.scrollTo({
        top: posY,
        behavior: 'smooth',
      });
    }
  }, [pathname]);

  useEffect(() => {
    if (confirm === true) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [confirm]);

  return (
    <>
      <section className="common contactPartnerMain">
        <div className="container">
          <div className="mainTit contactTit">
            <h2>제휴문의</h2>
            <p>Home > Contact Us > 제휴문의</p>
          </div>
        </div>
      </section>
      <section className="recruitment">
        <div className="w1200">
          <div className="tit">
            <p>
              성공적인 비즈니스의 시작, <br />
              (주)위더스 시큐리티와 함께 비전을 나눌
            </p>
            <h2>
              공식 파트너사 <span className="light">절찬 모집</span>
            </h2>
          </div>
          <ul className="boxContainer flex">
            <li>
              <span>혜택 01</span>
              <h3>
                영업 보호권
                <br />
                우선 제공
              </h3>
              <p>
                위더스 시큐리티 공식 파트너사가 <br />
                영업 중인 고객사에 대한 <br />
                영업 보호권을 우선 제공합니다.
              </p>
            </li>
            <li>
              <span>혜택 02</span>
              <h3>
                이벤트·프로모션 가격 <br />
                우선 적용
              </h3>
              <p>
                위더스 시큐리티 공식 파트너사에게 <br />
                프로모션 및 이벤트 행사소식을 <br /> 우선적으로 공지하고, 프로모션 <br />
                가격으로 제품을 제공합니다.
              </p>
            </li>
            <li>
              <span>혜택 03</span>
              <h3>
                영업용 자료 및 지원 <br />
                프로그램 제공
              </h3>
              <p>
                위더스 시큐리티 공식 파트너사에게 <br /> 영업 교육 자료 및 최신 보안 이슈 <br />
                자료를 지원하고, 맞춤형 지원 <br />
                프로그램을 제공합니다.
              </p>
            </li>
            <li>
              <span>혜택 04</span>
              <h3>
                위더스 시큐리티
                <br /> 전문인력 투입
              </h3>
              <p>
                파트너사가 고객사 소개 및 계약에 <br /> 집중하도록, 제품 설명 및 중간점검, <br />{' '}
                제품 설치 및 유지보수는 위더스 <br /> 시큐리티의 전문 인력이 제공합니다.
              </p>
            </li>
          </ul>
        </div>
      </section>
      <section className="support">
        <div className="w1200">
          <h2>
            위더스 시큐리티 <br />
            고객 지원 사항
          </h2>
          <div className="flex">
            <ul>
              <li>
                <p>제품 설명부터 유지보수까지 전담 진행</p>
              </li>
              <li>
                <p>고객사 및 파트너사 맞춤형 지원 프로그램 실시</p>
              </li>
              <li>
                <p>24시간 365일 문의 상시 대응</p>
              </li>
              <li>
                <p>시스템 문제 시 우선 원격 지원 서비스</p>
              </li>
            </ul>
            <ul>
              <li>
                <p>장비 문제 시 48시간 이내 방문 조치</p>
              </li>
              <li>
                <p>별도 커스터마이징 기능 추가 가능</p>
              </li>
              <li>
                <p>보안관제 및 정보보안 인프라 운영</p>
              </li>
              <li>
                <p>예방적 위험 탐지, 보안 위험 차단</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="contactPartner" ref={locationRef}>
        <form onSubmit={onSubmitRequest}>
          <div className="w1200">
            <div className="tit">
              <h2>제휴문의</h2>
              <p className="notice">
                아래 내용을 작성해 주시면 담당자가 확인 후 <br />
                신속하게 연락드리겠습니다.
              </p>
            </div>
            <div className="pd50">
              <div className="inputForm">
                <label>
                  <span>회사명</span>
                  <input
                    type="text"
                    placeholder="회사명을 입력해 주세요."
                    name="cor_name"
                    value={cor_name}
                    onChange={handleOnChange}
                    ref={(el) => (partnerRef.current[0] = el)}
                    title="회사명을 입력해주세요."
                  />
                </label>
                <label>
                  <span>담당자명</span>
                  <input
                    type="text"
                    placeholder="담당자명을 입력해 주세요."
                    name="mng_name"
                    value={mng_name}
                    onChange={handleOnChange}
                    ref={(el) => (partnerRef.current[1] = el)}
                    title="담당자명을 입력해주세요."
                  />
                </label>
                <label>
                  <span>연락처</span>
                  <div className="num">
                    <select
                      className="phone"
                      name="phone1"
                      value={phone1}
                      onChange={handleOnChange}
                    >
                      <option value="010">010</option>
                      <option value="011">011</option>
                      <option value="016">016</option>
                      <option value="017">017</option>
                      <option value="018">018</option>
                      <option value="019">019</option>
                    </select>
                    -
                    <input
                      type="text"
                      className="phone"
                      maxLength="4"
                      name="phone2"
                      value={phone2?.replace(/[^0-9]/g, '') || ''}
                      onChange={handleOnChange}
                      ref={(el) => (partnerRef.current[2] = el)}
                      title="연락처를 입력해주세요."
                    />
                    -
                    <input
                      type="text"
                      className="phone"
                      maxLength="4"
                      name="phone3"
                      value={phone3?.replace(/[^0-9]/g, '') || ''}
                      onChange={handleOnChange}
                      ref={(el) => (partnerRef.current[3] = el)}
                      title="연락처를 입력해주세요."
                    />
                  </div>
                </label>
                <label className="wp100">
                  <span className="email">이메일</span>
                  <div className="mail">
                    <input
                      placeholder="이메일을 입력해 주세요."
                      value={emailAccount}
                      name="emailAccount"
                      onChange={handleOnChange}
                      ref={(el) => (partnerRef.current[4] = el)}
                      title="이메일을 입력해 주세요."
                    />
                    <span className="mailIcon">@</span>
                    <input
                      type="text"
                      value={emailDomain === '' ? emailDomain : emailDomain}
                      name="emailDomain"
                      onChange={handleOnChange}
                      ref={(el) => (partnerRef.current[5] = el)}
                      title="이메일 도메인을 입력해주세요."
                    />
                    <select onChange={handleOnChange} value={emailDomain} name="emailDomain">
                      <option value="" defaultValue>
                        직접입력
                      </option>
                      <option value="gmail.com">gmail.com</option>
                      <option value="naver.com">naver.com</option>
                      <option value="hanmail.net">hanmail.net</option>
                    </select>
                  </div>
                </label>
                <label className="contentInquiry">
                  <span>문의 내용</span>
                  <textarea
                    name="contents"
                    placeholder="내용을 입력해 주세요."
                    value={contents}
                    onChange={handleOnChange}
                    ref={(el) => (partnerRef.current[6] = el)}
                    title="문의 내용을 입력해주세요."
                  />
                </label>
                <div className="notice flex">
                  <span>
                    안내 사항<span className="blue">*</span>
                  </span>
                  <p>
                    (주)위더스 시큐리티 이하 “회사”는 개인정보보호법 및 정보통신망법에 의거 개인정보
                    수집 시 아래와 같은 사항을 알려드리며,
                    <br />
                    본인의 동의를 받고 있으니 동의여부에 따른 서명을 해 주시기 바랍니다.
                  </p>
                </div>
              </div>
              <div className="ConsentUse">
                <ProductPersoanlInfo agree={agree} setAgree={setAgree} />
              </div>
              <div className="btn">
                <button className="apply">문의하기</button>
              </div>
            </div>
          </div>
        </form>
      </section>
      {closePopUp && <Confirmodal closePop={closePopup} />}
    </>
  );
};

export default ContactPartner;
